import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { color } from '../../../api/ColorsSector'
import { adress } from '../../../api/waterAdress'
import { formatWeight } from '../../../api/FormatWeight'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center',
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})
const PairComandSvodGroupTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {adress(tournament.water_id)
                  ? adress(tournament.water_id)
                  : tournament.water_body}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 10,
          }}
        >
          {/* {isfinish ? ():()} */}
          СВОДНЫЙ ПРОТОКОЛ ПО ГРУППАМ
        </Text>
        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 13 }}>
          Ловля карпа – парные соревнования (мужчины, женщины), номер - код
          дисциплины 0920151811Л
        </Text>
        {data['А'] && data['А'].length > 0 && (
          <>
            <View>
              <View
                style={{
                  width: '100%',
                  borderStyle: 'solid',
                  borderWidth: 0.3,
                  borderColor: '#000',
                }}
              >
                <View
                  style={{
                    height: '40px',
                    flexDirection: 'row',
                    alignItems: 'stretch',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}> Место в группе</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '34%' }]}>
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      Команда (пара), состав (Ф.И.О./разряд)
                    </Text>
                  </View>
                  {/* 12 */}

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Группа</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Сектор</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}> Кол-во</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>Вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Крупная рыба</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Средний вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>До лидера группы</Text>
                  </View>
                </View>
              </View>
            </View>
            {data['А'].map((item, index) => (
              <View key={index} wrap={false}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'stretch',
                    backgroundColor:
                      item.bestResult < 4
                        ? '#fff'
                        : item.bestResult === 0
                          ? '#fff'
                          : '#fff',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>{item.zoneRank}</Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '34%', alignItems: 'flex-start' },
                    ]}
                  >
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      <Text style={{ fontWeight: 'bold' }}>{item.team}</Text>
                      {'\n'}
                      {item.sp}
                    </Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '7%', backgroundColor: color(item.zone) },
                    ]}
                  >
                    <Text style={styles.tableText}>{item.zone}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}>{item.sector}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.fishCount)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.totalWeight)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.biggestFish)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.averageWeight)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.weightBehindLeader)}
                    </Text>
                  </View>
                </View>
              </View>
            ))}

            <View
              style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  backgroundColor: '#fff',
                }}
              >
                <Text
                  style={{
                    width: '9%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    textAlign: 'right',
                    width: '34%',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  ВСЕГО
                </Text>
                <Text
                  style={{
                    width: '14%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalFishCount.А)}
                </Text>
                <Text
                  style={{
                    width: '10%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalWeight.А)}
                </Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(averageFishWeight.А)}
                </Text>
              </View>
            </View>
          </>
        )}

        {data['Б'] && data['Б'].length > 0 && (
          <>
            <View>
              <View
                style={{
                  width: '100%',
                  borderStyle: 'solid',
                  borderWidth: 0.3,
                  borderColor: '#000',
                  marginTop: '20px',
                }}
              >
                <View
                  style={{
                    height: '40px',
                    flexDirection: 'row',
                    alignItems: 'stretch',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}> Место в группе</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '34%' }]}>
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      Команда (пара), состав (Ф.И.О./разряд)
                    </Text>
                  </View>
                  {/* 12 */}

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Группа</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Сектор</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}> Кол-во</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>Вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Крупная рыба</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Средний вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>До лидера группы</Text>
                  </View>
                </View>
              </View>
            </View>
            {data['Б'].map((item, index) => (
              <View key={index} wrap={false}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'stretch',
                    backgroundColor:
                      item.bestResult < 4
                        ? '#fff'
                        : item.bestResult === 0
                          ? '#fff'
                          : '#fff',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>{item.zoneRank}</Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '34%', alignItems: 'flex-start' },
                    ]}
                  >
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      <Text style={{ fontWeight: 'bold' }}>{item.team}</Text>
                      {'\n'}
                      {item.sp}
                    </Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '7%', backgroundColor: color(item.zone) },
                    ]}
                  >
                    <Text style={styles.tableText}>{item.zone}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}>{item.sector}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.fishCount)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.totalWeight)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.biggestFish)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.averageWeight)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.weightBehindLeader)}
                    </Text>
                  </View>
                </View>
              </View>
            ))}

            <View
              style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  backgroundColor: '#fff',
                }}
              >
                <Text
                  style={{
                    width: '9%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    textAlign: 'right',
                    width: '34%',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  ВСЕГО
                </Text>
                <Text
                  style={{
                    width: '14%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalFishCount.Б)}
                </Text>
                <Text
                  style={{
                    width: '10%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalWeight.Б)}
                </Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(averageFishWeight.Б)}
                </Text>
              </View>
            </View>
          </>
        )}

        {data['В'] && data['В'].length > 0 && (
          <>
            <View>
              <View
                style={{
                  width: '100%',
                  borderStyle: 'solid',
                  borderWidth: 0.3,
                  borderColor: '#000',
                  marginTop: '20px',
                }}
              >
                <View
                  style={{
                    height: '40px',
                    flexDirection: 'row',
                    alignItems: 'stretch',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}> Место в группе</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '34%' }]}>
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      Команда (пара), состав (Ф.И.О./разряд)
                    </Text>
                  </View>
                  {/* 12 */}

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Группа</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}> Сектор</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}> Кол-во</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>Вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Крупная рыба</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>Средний вес</Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>До лидера группы</Text>
                  </View>
                </View>
              </View>
            </View>
            {data['В'].map((item, index) => (
              <View key={index} wrap={false}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'stretch',
                    backgroundColor:
                      item.bestResult < 4
                        ? '#fff'
                        : item.bestResult === 0
                          ? '#fff'
                          : '#fff',
                  }}
                >
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>{item.zoneRank}</Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '34%', alignItems: 'flex-start' },
                    ]}
                  >
                    <Text style={[styles.tableText, { textAlign: 'left' }]}>
                      <Text style={{ fontWeight: 'bold' }}>{item.team}</Text>
                      {'\n'}
                      {item.sp}
                    </Text>
                  </View>

                  <View
                    style={[
                      styles.tableColHeader,
                      { width: '7%', backgroundColor: color(item.zone) },
                    ]}
                  >
                    <Text style={styles.tableText}>{item.zone}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '7%' }]}>
                    <Text style={styles.tableText}>{item.sector}</Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.fishCount)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '10%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.totalWeight)}
                    </Text>
                  </View>

                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.biggestFish)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '8%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.averageWeight)}
                    </Text>
                  </View>
                  <View style={[styles.tableColHeader, { width: '9%' }]}>
                    <Text style={styles.tableText}>
                      {formatWeight(item.weightBehindLeader)}
                    </Text>
                  </View>
                </View>
              </View>
            ))}

            <View
              style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  backgroundColor: '#fff',
                }}
              >
                <Text
                  style={{
                    width: '9%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    textAlign: 'right',
                    width: '34%',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  ВСЕГО
                </Text>
                <Text
                  style={{
                    width: '14%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>

                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalFishCount.В)}
                </Text>
                <Text
                  style={{
                    width: '10%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(totalWeight.В)}
                </Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                ></Text>
                <Text
                  style={{
                    width: '8%',
                    textAlign: 'center',
                    fontSize: 8,
                    padding: 2,
                  }}
                >
                  {formatWeight(averageFishWeight.В)}
                </Text>
              </View>
            </View>
          </>
        )}

        {/* Биги */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 10,
          }}
        >
          <View
            style={{
              width: '50%',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
              }}
            >
              Самая крупная рыба: {formatWeight(biggestFish.weight)}
            </Text>
          </View>
          {/* <View
          style={{
            width: '50%',
          }}
        >
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (1 суток): 14 870
          </Text>
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (2 суток): 14 870
          </Text>
          <Text
            style={{
              fontSize: '8px',
            }}
          >
            Самая крупная рыба (3 суток): 14 870
          </Text>
        </View> */}
        </View>

        {/* Подписи */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '45%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text
              style={{
                fontSize: '8px',
                textAlign: 'center',
              }}
            >
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
        </View>

        {/* Логотипы партнеров */}
        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default PairComandSvodGroupTournamentProtocolPDF
